/** Do not edit this file, it is automatically generated **/
import React, { PropsWithChildren } from "react";
import styled from "styled-components";

import Icon, { IconProps } from "./Icon";

const IconRemoveLineComponent: React.FC<PropsWithChildren<IconProps>> & { DataUrl: string; Content: string; } = (props) => {
return (
  <Icon {...props} viewBox="0 0 357 357">
    <g>
    <g id="close">
        <polygon points="357,35.7 321.3,0 178.5,142.8 35.7,0 0,35.7 142.8,178.5 0,321.3 35.7,357 178.5,214.2 321.3,357 357,321.3 214.2,178.5 ">
        </polygon>
    </g>
</g>
  </Icon>
);
};

IconRemoveLineComponent.DataUrl = "data:image/svg+xml;charset=utf-8;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMzU3IDM1NyIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8Zz4KICAgIDxnIGlkPSJjbG9zZSI+CiAgICAgIDxwb2x5Z29uIHBvaW50cz0iMzU3LDM1LjcgMzIxLjMsMCAxNzguNSwxNDIuOCAzNS43LDAgMCwzNS43IDE0Mi44LDE3OC41IDAsMzIxLjMgMzUuNywzNTcgMTc4LjUsMjE0LjIgMzIxLjMsMzU3IDM1NywzMjEuMyAyMTQuMiwxNzguNSAiPgogICAgICA8L3BvbHlnb24+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4=";
IconRemoveLineComponent.Content = `<svg viewBox="0 0 357 357" xmlns="http://www.w3.org/2000/svg">
  <g>
    <g id="close">
      <polygon points="357,35.7 321.3,0 178.5,142.8 35.7,0 0,35.7 142.8,178.5 0,321.3 35.7,357 178.5,214.2 321.3,357 357,321.3 214.2,178.5 ">
      </polygon>
    </g>
  </g>
</svg>`;

const IconRemoveLine = styled(IconRemoveLineComponent)``;

export default IconRemoveLine;
